define((require) => {
    "use strict";

    var EditorActivity  = require("editor/ui/experience/editor/activity/EditorActivity");

    /**
     * An activity representing the disposal of a <tt>Scene</tt> model.
     *
     * @class SceneDeletedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _sceneModel: null,

        _experienceModel: null,

        _index: null,

        constructor: function(sceneModel, experienceModel, index) {
            this._sceneModel = sceneModel;
            this._experienceModel = experienceModel;
            this._index = index;
        },

        _onUndo: function() {
            // Make sure the Scene model does not contain an ID when re-adding it to the
            // experience - it should represent a new scene, otherwise the backend will
            // start complaining...
            this._experienceModel.addScene(this._index + 1, this._sceneModel.clone({duplicate: true}));
        },

        _onRedo: function() {
            this._experienceModel.removeScene(this._sceneModel);
        },

        dispose: function() {
            this._sceneModel = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/SceneDeletedActivity.js